<ll-toolnavbar>
    <plan_estudio-toolnavbar></plan_estudio-toolnavbar>
</ll-toolnavbar>
<ll-titulo>Planes de Estudio</ll-titulo>

<plan_estudios listRoute="plan_estudios"></plan_estudios>
